/* eslint-disable */
/* tslint:disable */
// noinspection JSUnusedGlobalSymbols
// biome-ignore-all
/*
 * ------------------------------------------------------------
 * ## This file was automatically generated by drizzle-zero. ##
 * ## Any changes you make to this file will be overwritten. ##
 * ##                                                        ##
 * ## Additionally, you should also exclude this file from   ##
 * ## your linter and/or formatter to prevent it from being  ##
 * ## checked or modified.                                   ##
 * ##                                                        ##
 * ## SOURCE: https://github.com/0xcadams/drizzle-zero        ##
 * ------------------------------------------------------------
 */

import type { ZeroCustomType } from "drizzle-zero";
import type { schema as zeroSchema } from "../../drizzle-zero.config";

/**
 * The Zero schema object.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const schema = {
  tables: {
    BackfillStatusTable: {
      name: "BackfillStatusTable",
      columns: {
        id: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BackfillStatusTable",
            "id"
          >,
        },
        status: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BackfillStatusTable",
            "status"
          >,
        },
        steps: {
          type: "json",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BackfillStatusTable",
            "steps"
          >,
        },
        errors: {
          type: "json",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BackfillStatusTable",
            "errors"
          >,
        },
        installationId: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BackfillStatusTable",
            "installationId"
          >,
          serverName: "installation_id",
        },
        completedAt: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BackfillStatusTable",
            "completedAt"
          >,
          serverName: "completed_at",
        },
        createdAt: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BackfillStatusTable",
            "createdAt"
          >,
          serverName: "created_at",
        },
      },
      primaryKey: ["id"],
      serverName: "backfill_status",
    },
    BranchPushesTable: {
      name: "BranchPushesTable",
      columns: {
        id: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "id"
          >,
        },
        owner: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "owner"
          >,
        },
        repo: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "repo"
          >,
        },
        branch: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "branch"
          >,
        },
        pusherLogin: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "pusherLogin"
          >,
          serverName: "pusher_login",
        },
        pusherId: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "pusherId"
          >,
          serverName: "pusher_id",
        },
        headSha: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "headSha"
          >,
          serverName: "head_sha",
        },
        latestCommitMessage: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "latestCommitMessage"
          >,
          serverName: "latest_commit_message",
        },
        latestCommitAuthor: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "latestCommitAuthor"
          >,
          serverName: "latest_commit_author",
        },
        pushedAt: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "pushedAt"
          >,
          serverName: "pushed_at",
        },
        dismissed: {
          type: "boolean",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "dismissed"
          >,
        },
        pullRequestCreated: {
          type: "boolean",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "pullRequestCreated"
          >,
          serverName: "pull_request_created",
        },
        pullRequestNumber: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "pullRequestNumber"
          >,
          serverName: "pull_request_number",
        },
        defaultBranch: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "defaultBranch"
          >,
          serverName: "default_branch",
        },
        createdAt: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "createdAt"
          >,
          serverName: "created_at",
        },
        updatedAt: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "BranchPushesTable",
            "updatedAt"
          >,
          serverName: "updated_at",
        },
      },
      primaryKey: ["id"],
      serverName: "branch_pushes",
    },
    CheckRunsTable: {
      name: "CheckRunsTable",
      columns: {
        nodeId: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "nodeId"
          >,
          serverName: "node_id",
        },
        id: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "id"
          >,
        },
        name: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "name"
          >,
        },
        conclusion: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "conclusion"
          >,
        },
        status: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "status"
          >,
        },
        headSha: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "headSha"
          >,
          serverName: "head_sha",
        },
        startedAt: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "startedAt"
          >,
          serverName: "started_at",
        },
        completedAt: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "completedAt"
          >,
          serverName: "completed_at",
        },
        htmlUrl: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "htmlUrl"
          >,
          serverName: "html_url",
        },
        checkSuiteId: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "checkSuiteId"
          >,
          serverName: "check_suite_id",
        },
        installationId: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "installationId"
          >,
          serverName: "installation_id",
        },
        owner: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "owner"
          >,
        },
        repository: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckRunsTable",
            "repository"
          >,
        },
      },
      primaryKey: ["nodeId"],
      serverName: "check_runs",
    },
    CheckSuiteTable: {
      name: "CheckSuiteTable",
      columns: {
        nodeId: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "nodeId"
          >,
          serverName: "node_id",
        },
        id: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "id"
          >,
        },
        conclusion: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "conclusion"
          >,
        },
        status: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "status"
          >,
        },
        rerequestable: {
          type: "boolean",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "rerequestable"
          >,
        },
        runs_rerequestable: {
          type: "boolean",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "runs_rerequestable"
          >,
        },
        latest_check_runs_count: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "latest_check_runs_count"
          >,
        },
        headBranch: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "headBranch"
          >,
          serverName: "head_branch",
        },
        headSha: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "headSha"
          >,
          serverName: "head_sha",
        },
        before: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "before"
          >,
        },
        after: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "after"
          >,
        },
        check_runs_url: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "check_runs_url"
          >,
        },
        createdAt: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "createdAt"
          >,
          serverName: "created_at",
        },
        updatedAt: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "updatedAt"
          >,
          serverName: "updated_at",
        },
        installationId: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "installationId"
          >,
          serverName: "installation_id",
        },
        owner: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "owner"
          >,
        },
        repository: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "CheckSuiteTable",
            "repository"
          >,
        },
      },
      primaryKey: ["nodeId"],
      serverName: "check_suites",
    },
    IssueCommentsTable: {
      name: "IssueCommentsTable",
      columns: {
        gid: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "IssueCommentsTable",
            "gid"
          >,
        },
        id: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "IssueCommentsTable",
            "id"
          >,
        },
        body: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "IssueCommentsTable",
            "body"
          >,
        },
        authorLogin: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "IssueCommentsTable",
            "authorLogin"
          >,
          serverName: "author_login",
        },
        author: {
          type: "json",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "IssueCommentsTable",
            "author"
          >,
        },
        authorAssociation: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "IssueCommentsTable",
            "authorAssociation"
          >,
          serverName: "author_association",
        },
        owner: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "IssueCommentsTable",
            "owner"
          >,
        },
        repo: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "IssueCommentsTable",
            "repo"
          >,
        },
        issueNumber: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "IssueCommentsTable",
            "issueNumber"
          >,
          serverName: "issue_number",
        },
        createdAt: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "IssueCommentsTable",
            "createdAt"
          >,
          serverName: "created_at",
        },
        updatedAt: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "IssueCommentsTable",
            "updatedAt"
          >,
          serverName: "updated_at",
        },
      },
      primaryKey: ["gid"],
      serverName: "issue_comments",
    },
    OrgConfigTable: {
      name: "OrgConfigTable",
      columns: {
        installationId: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "OrgConfigTable",
            "installationId"
          >,
          serverName: "installation_id",
        },
        owner: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "OrgConfigTable",
            "owner"
          >,
        },
        config: {
          type: "json",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "OrgConfigTable",
            "config"
          >,
        },
        updatedAt: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "OrgConfigTable",
            "updatedAt"
          >,
          serverName: "updated_at",
        },
      },
      primaryKey: ["owner"],
      serverName: "org_configs",
    },
    PullDiffsTable: {
      name: "PullDiffsTable",
      columns: {
        uuid: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullDiffsTable",
            "uuid"
          >,
        },
        id: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullDiffsTable",
            "id"
          >,
        },
        owner: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullDiffsTable",
            "owner"
          >,
        },
        repo: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullDiffsTable",
            "repo"
          >,
        },
        number: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullDiffsTable",
            "number"
          >,
        },
        commitSha: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullDiffsTable",
            "commitSha"
          >,
          serverName: "commit_sha",
        },
        diff: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullDiffsTable",
            "diff"
          >,
        },
        fileSummaries: {
          type: "json",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullDiffsTable",
            "fileSummaries"
          >,
          serverName: "file_summaries",
        },
        groupedDiffs: {
          type: "json",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullDiffsTable",
            "groupedDiffs"
          >,
          serverName: "grouped_diffs",
        },
        isGenerating: {
          type: "boolean",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullDiffsTable",
            "isGenerating"
          >,
          serverName: "is_generating",
        },
      },
      primaryKey: ["uuid"],
      serverName: "pull_diffs",
    },
    PullsTable: {
      name: "PullsTable",
      columns: {
        nodeId: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "nodeId"
          >,
          serverName: "node_id",
        },
        id: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "id"
          >,
        },
        owner: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "owner"
          >,
        },
        repo: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "repo"
          >,
        },
        number: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "number"
          >,
        },
        title: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "title"
          >,
        },
        body: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "body"
          >,
        },
        state: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "state"
          >,
        },
        reviewDecision: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "reviewDecision"
          >,
          serverName: "review_decision",
        },
        mergeable: {
          type: "boolean",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "mergeable"
          >,
        },
        rebaseable: {
          type: "boolean",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "rebaseable"
          >,
        },
        mergeableState: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "mergeableState"
          >,
          serverName: "mergeable_state",
        },
        additions: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "additions"
          >,
        },
        deletions: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "deletions"
          >,
        },
        author: {
          type: "json",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "author"
          >,
        },
        authorAssociation: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "authorAssociation"
          >,
          serverName: "author_association",
        },
        labels: {
          type: "json",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "labels"
          >,
        },
        head: {
          type: "json",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "head"
          >,
        },
        base: {
          type: "json",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "base"
          >,
        },
        requestedReviewers: {
          type: "json",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "requestedReviewers"
          >,
          serverName: "requested_reviewers",
        },
        assignees: {
          type: "json",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "assignees"
          >,
        },
        checkStatusRollup: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "checkStatusRollup"
          >,
          serverName: "check_status_rollup",
        },
        commentCount: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "commentCount"
          >,
          serverName: "comment_count",
        },
        mergedBy: {
          type: "json",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "mergedBy"
          >,
          serverName: "merged_by",
        },
        mergeCommitSha: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "mergeCommitSha"
          >,
          serverName: "merge_commit_sha",
        },
        closedAt: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "closedAt"
          >,
          serverName: "closed_at",
        },
        mergedAt: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "mergedAt"
          >,
          serverName: "merged_at",
        },
        createdAt: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "createdAt"
          >,
          serverName: "created_at",
        },
        updatedAt: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "PullsTable",
            "updatedAt"
          >,
          serverName: "updated_at",
        },
      },
      primaryKey: ["nodeId"],
      serverName: "pulls",
    },
    ReactionsTable: {
      name: "ReactionsTable",
      columns: {
        gid: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReactionsTable",
            "gid"
          >,
        },
        id: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReactionsTable",
            "id"
          >,
        },
        commentId: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReactionsTable",
            "commentId"
          >,
          serverName: "comment_id",
        },
        commentType: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReactionsTable",
            "commentType"
          >,
          serverName: "comment_type",
        },
        userId: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReactionsTable",
            "userId"
          >,
          serverName: "user_id",
        },
        emoji: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReactionsTable",
            "emoji"
          >,
        },
      },
      primaryKey: ["gid"],
      serverName: "reactions",
    },
    ReviewCommentsTable: {
      name: "ReviewCommentsTable",
      columns: {
        gid: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "gid"
          >,
        },
        id: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "id"
          >,
        },
        body: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "body"
          >,
        },
        authorLogin: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "authorLogin"
          >,
          serverName: "author_login",
        },
        author: {
          type: "json",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "author"
          >,
        },
        authorAssociation: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "authorAssociation"
          >,
          serverName: "author_association",
        },
        commitId: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "commitId"
          >,
          serverName: "commit_id",
        },
        inReplyToId: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "inReplyToId"
          >,
          serverName: "in_reply_to_id",
        },
        path: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "path"
          >,
        },
        startLine: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "startLine"
          >,
          serverName: "start_line",
        },
        line: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "line"
          >,
        },
        side: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "side"
          >,
        },
        type: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "type"
          >,
        },
        severity: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "severity"
          >,
        },
        isBad: {
          type: "boolean",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "isBad"
          >,
          serverName: "is_bad",
        },
        reviewId: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "reviewId"
          >,
          serverName: "review_id",
        },
        externalReviewId: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "externalReviewId"
          >,
          serverName: "external_review_id",
        },
        resolvedById: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "resolvedById"
          >,
          serverName: "resolved_by_id",
        },
        isOutdated: {
          type: "boolean",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "isOutdated"
          >,
          serverName: "is_outdated",
        },
        owner: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "owner"
          >,
        },
        repo: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "repo"
          >,
        },
        pullNumber: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "pullNumber"
          >,
          serverName: "pull_number",
        },
        createdAt: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "createdAt"
          >,
          serverName: "created_at",
        },
        updatedAt: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewCommentsTable",
            "updatedAt"
          >,
          serverName: "updated_at",
        },
      },
      primaryKey: ["gid"],
      serverName: "review_comments",
    },
    ReviewTable: {
      name: "ReviewTable",
      columns: {
        gid: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "gid"
          >,
        },
        id: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "id"
          >,
        },
        nodeId: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "nodeId"
          >,
          serverName: "node_id",
        },
        state: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "state"
          >,
        },
        commitId: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "commitId"
          >,
          serverName: "commit_id",
        },
        body: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "body"
          >,
        },
        agentVersion: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "agentVersion"
          >,
          serverName: "agent_version",
        },
        author: {
          type: "json",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "author"
          >,
        },
        authorAssociation: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "authorAssociation"
          >,
          serverName: "author_association",
        },
        installationId: {
          type: "number",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "installationId"
          >,
          serverName: "installation_id",
        },
        owner: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "owner"
          >,
        },
        repo: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "repo"
          >,
        },
        pullNumber: {
          type: "number",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "pullNumber"
          >,
          serverName: "pull_number",
        },
        createdAt: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "createdAt"
          >,
          serverName: "created_at",
        },
        updatedAt: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "ReviewTable",
            "updatedAt"
          >,
          serverName: "updated_at",
        },
      },
      primaryKey: ["gid"],
      serverName: "reviews",
    },
    UserPreferencesTable: {
      name: "UserPreferencesTable",
      columns: {
        id: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "UserPreferencesTable",
            "id"
          >,
        },
        userId: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "UserPreferencesTable",
            "userId"
          >,
          serverName: "user_id",
        },
        organizationId: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "UserPreferencesTable",
            "organizationId"
          >,
          serverName: "organization_id",
        },
        layoutType: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "UserPreferencesTable",
            "layoutType"
          >,
          serverName: "layout_type",
        },
        layoutKey: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "UserPreferencesTable",
            "layoutKey"
          >,
          serverName: "layout_key",
        },
        layoutValue: {
          type: "string",
          optional: false,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "UserPreferencesTable",
            "layoutValue"
          >,
          serverName: "layout_value",
        },
        createdAt: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "UserPreferencesTable",
            "createdAt"
          >,
          serverName: "created_at",
        },
        updatedAt: {
          type: "string",
          optional: true,
          customType: null as unknown as ZeroCustomType<
            typeof zeroSchema,
            "UserPreferencesTable",
            "updatedAt"
          >,
          serverName: "updated_at",
        },
      },
      primaryKey: ["id"],
      serverName: "user_preferences",
    },
  },
  relationships: {
    CheckRunsTable: {
      checkSuite: [
        {
          sourceField: ["checkSuiteId"],
          destField: ["id"],
          destSchema: "CheckSuiteTable",
          cardinality: "one",
        },
      ],
    },
    CheckSuiteTable: {
      checkRuns: [
        {
          sourceField: ["id"],
          destField: ["checkSuiteId"],
          destSchema: "CheckRunsTable",
          cardinality: "many",
        },
      ],
    },
    PullsTable: {
      diffs: [
        {
          sourceField: ["id"],
          destField: ["id"],
          destSchema: "PullDiffsTable",
          cardinality: "one",
        },
      ],
    },
    ReviewCommentsTable: {
      review: [
        {
          sourceField: ["reviewId"],
          destField: ["gid"],
          destSchema: "ReviewTable",
          cardinality: "one",
        },
      ],
    },
    ReviewTable: {
      comments: [
        {
          sourceField: ["gid"],
          destField: ["reviewId"],
          destSchema: "ReviewCommentsTable",
          cardinality: "many",
        },
      ],
    },
  },
} as const;

/**
 * Represents the Zero schema type.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Schema = typeof schema;
